import Immutable from 'immutable';
import { PageId } from 'records/Page';
import { UpdateSheetDiscipline } from 'records/UpdateSheetDiscipline';

export interface RawUpdateSheet {
  projectid: string;
  pageids: PageId[];
  discipline: string;
  issueddate: number;
  revisioncomment: string;
}

export interface UpdateSheetData {
  projectid: string;
  pageids: PageId[];
  discipline: string;
  sheetDiscipline?: UpdateSheetDiscipline;
  issueddate: number;
  revisioncomment: string;
}

const defaultValues: UpdateSheetData = {
  projectid: '',
  pageids: [],
  discipline: '',
  sheetDiscipline: undefined,
  issueddate: 0,
  revisioncomment: '',
};

export const UpdateSheetFactory = Immutable.Record(
  defaultValues,
  'UpdateSheet'
);

export class UpdateSheet extends UpdateSheetFactory {}
